export default __webpack_public_path__ + "33ccbdbdb6cb16c5ce271a27bd7e7281.svg";